<template>
  <div class="login">
    <!-- 头部 -->
    <header>
      <a class="left">
        <router-link to="/home">
          <img class="logo" src="../assets/logo.png" />
        </router-link>
        <!-- <span class="logo-name">CRC备案平台</span>
        -->
      </a>
      <!-- <span class="logo-fl">公司端</span> -->
      <a class="right tel">客服热线：010--86463913</a>
    </header>
    <!-- 内容区域 -->
    <div class="content">
      <div>
        <img src="../assets/cback.png" class="img-back" />
      </div>
      <div class="login-right">
        <div class="Name">公司用户</div>
        <!-- tab标签 -->
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="账号登录" name="first">
            <div class="content1">
              <p>
                <span class="input-text">用户名：</span>
                <el-input
                  v-model="mobile"
                  placeholder="请输入用户名或者手机号"
                  @keyup.enter.native="logining()"
                  class="enterinput"
                ></el-input>
              </p>
              <p>
                <span class="input-text">密&nbsp;&nbsp;码：</span>
                <el-input
                  show-password
                  v-model="password"
                  placeholder="请输入密码"
                  @keyup.enter.native="logining()"
                  class="enterinput"
                ></el-input>
              </p>
              <div class="sub-btn" v-on:click="logining">登录</div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="扫码登录" name="second">扫码登录</el-tab-pane> -->
          <el-tab-pane label="短信登录" name="third">
            <div class="content1">
              <p>
                <span class="input-text">手机号：</span>
                <el-input type="text" v-model="mobile2" placeholder="请输入手机号" class="enterinput"></el-input>
              </p>
              <p>
                <span class="input-text">图形码：</span>
                <el-input type="text" class="code" placeholder="输入验证码" v-model="imgcodeinput"></el-input>
                <img
                  :src="imgCode"
                  style="vertical-align:middle;margin-left: 20px;"
                  @click="Refresh"
                />
              </p>
              <p>
                <span class="input-text">验证码：</span>
                <el-input type="text" class="code" placeholder="输入验证码" v-model="smsCode"></el-input>
                <a class="codebtn" @click="send" v-if="Verification">获取验证码</a>
                <a class="codebtn nobtn" v-if="!Verification">{{time}}s后重新获取</a>
              </p>
              <div class="sub-btn" v-on:click="logining2">登录</div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- 微信注册忘记密码 -->
        <div class="bottom-btn">
          <p @click="wxtab" class="wx-login-btn left">
            <img src="../assets/w-icon.png" />
            <span>微信登录</span>
          </p>
          <p class="right wx-login-btn" style="color:#E0E0E0">
            <router-link to="/register-company/0/0">立即注册</router-link>
          </p>
        </div>
        <!-- 结束 -->
      </div>
    </div>
    <!-- <router-view /> -->
  </div>
</template>

<script>
import { loginInOut } from "@/request/api";
import { loginInOut2 } from "@/request/api";
import Cookies from "js-cookie";
import { getSmsCode } from "@/request/api";
import { loginInOut3 } from "@/request/api";

export default {
  name: "login",
  data() {
    return {
      activeName: "first",
      mobile: "",
      mobile2: "",
      password: "",
      smsCode: "",
      codeurl: this.Common.codeurl,
      href: this.Common.href,
      imgCode: this.Common.codeurl,
      imgcodeinput: "",
      Verification: true,
      time: 60,
      auth_timer: null,
      logintext: "账号登录"
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      console.log(tab.name);
      this.logintext = tab.name;
    },
    // 手机号登陆
    logining() {
      if (this.mobile == "" || this.password == "") {
        this.$message.error("请输入用户名或密码");
      } else {
        // if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        //   this.$message.error("手机号码格式错误");
        // } else {
          let data = {
            mobile: this.mobile,
            password: this.password,
            accountType: "1"
          };
          loginInOut(data)
          .then(res => {
            if (res.data.code == "00000") {
              Cookies.set("token", res.data.data.token);
              Cookies.set("userid", res.data.data.userId);
              console.log(res.data.data.token);
              Cookies.set("accountType", res.data.data.accountType);
              Cookies.set("isAdmin", res.data.data.isAdmin);
              Cookies.set("orgName", res.data.data.orgName);
              this.$message({
                message: "登录成功",
                type: "success",
                offset: 200
              });
              let userid = res.data.data.userId;
              console.log(res.data.data.regProgress);
              if (res.data.data.isAdmin == "8") {
                this.$router.replace("/hospitalaudit/hostla");
              } else {
                if (res.data.data.regProgress != 2) {
                  this.$router.replace("/register-company/2/" + userid);
                } else {
                  this.$router.replace("/CIndex/company-home");
                }
              }
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(err => {
            console.log(err);
          });
        // }
      }
    },
    // 验证码登陆
    logining2() {
      if (this.mobile2 == "" || this.smsCode == "") {
        this.$message.error("请输入手机号或验证码");
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.mobile2)) {
          this.$message.error("手机号码格式错误");
        } else {
          let data = {
            mobile: this.mobile2,
            code: this.smsCode,
            accountType: "1"
          };
          loginInOut2(data)
            .then(res => {
              if (res.data.code == "00000") {
                Cookies.set("token", res.data.data.token);
                Cookies.set("userid", res.data.data.userId);
                Cookies.set("accountType", res.data.data.accountType);
                console.log(res.data.data.token);

                this.$message({
                  message: "登录成功",
                  type: "success"
                });
                this.$router.replace("/CIndex/company-home");
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    },
    wxtab() {
      // 切换到微信登录，并且请求接口
      // this.activeName = "second";
      window.location.href =
        this.href + "/open/wxopen/qrAuthorize?returnUrl=https://www.gcphr.cn";
    },
    Refresh() {
      let num = Math.ceil(Math.random() * 10);
      this.imgCode = this.codeurl + "?" + num;
    },
    // 发送验证码
    send() {
      if (this.mobile2 == "" || this.imgcodeinput == "") {
        this.$message.error("手机号码或图形验证码不能为空");
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.mobile2)) {
          this.$message.error("手机号码格式错误");
        } else {
          let data = {
            codeType: "2",
            imgCode: this.imgcodeinput,
            mobile: this.mobile2
          };
          getSmsCode(data)
            .then(res => {
              let msg = res.data.message;
              if (res.data.code == "00000") {
                this.$message({
                  message: msg,
                  type: "success"
                });
                // 倒计时
                this.Verification = false; //点击button改变v-show的状态
                this.auth_timer = setInterval(() => {
                  //定时器设置每秒递减
                  this.time--; //递减时间
                  if (this.time <= 0) {
                    this.Verification = true; //60s时间结束还原v-show状态并清除定时器
                    clearInterval(this.auth_timer);
                    this.auth_timer = null;
                    this.time = 60;
                  }
                }, 1000);
              } else {
                this.$message.error(msg);
              }
              this.Refresh();
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  },
  mounted() {
    let that = this;
    let unionId1 = this.$utils.getUrlKey("unionId");
    let unionId = Cookies.set(unionId1);
    if (unionId1) {
      let data = {
        unionId: unionId1
      };
      loginInOut3(data)
        .then(res => {
          if (res.data.code == "00000") {
            CoCookies.set("token", res.data.data.token);
            Cookies.set("userid", res.data.data.userId);
            Cookies.set("accountType", res.data.data.accountType);
            console.log(res.data.data.token);
            that.$message({
              message: "登录成功",
              type: "success"
            });
            if (res.data.data.accountType == "1") {
              that.$router.replace("/CIndex/company-home"); //公司登录
            } else if (res.data.data.accountType == "2") {
              that.$router.replace("/HIndex/hostipal-home");
            } else {
              that.$router.push("/person-home");
            }
          } else {
            that.$router.replace("/Bind");
            that.$message.success(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var key =
        window.event.keyCode || window.event.which || window.event.charCode;

      if (key == "13" || key == "100") {
        // alert(that.logintext);
        if (that.logintext == "账号登录" || that.logintext == "") {
          that.logining();
        } else if (this.logintext == "短信登录") {
          ththatis.logining2();
        }
      }
    };
  }
};
</script>


<style scoped>
.input-text {
  display: inline-block;
  width: 70px;
}

header {
  width: 1100px;
  margin: 0 auto;
  margin-top: 43px;
  height: 40px;
}

header a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
}

header span {
  float: left;
}

.logo {
  display: table-cell;
  vertical-align: middle;
  float: left;
}

.left {
  float: left;
}

.right {
  float: right;
}

.logo-name {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular;
  font-weight: bold;
  color: #3771ca;
  margin-left: 14px;
}

.logo-fl {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: bold;
  color: rgba(77, 77, 77, 1);
  margin-left: 28px;
  line-height: 70px;
}
.tel {
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  font-weight: bold;
  color: rgba(55, 113, 202, 1);
}

.content {
  width: 1191px;
  margin: 0 auto;
  margin-top: 178px;
}

.content > div {
  float: left;
}

.login-right {
  position: relative;
  width: 520px;
  height: auto;
  /* padding:0 56px; */
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 32px 0px rgba(54, 114, 191, 0.29);
  border-radius: 4px;
  margin-left: -56px;
  /* margin-top: -41px; */
  padding-bottom: 80px;
}

.content1 {
  width: 100%;
  border-top: #e6e6e6;
  margin-top: 60px;
  box-sizing: border-box;
  padding: 0 56px;
}

.content1 p {
  margin-bottom: 35px;
}

.sub-btn {
  width: 400px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: rgba(54, 114, 191, 1);
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.content1 input {
  width: 332px;
  height: 46px;
  background: rgba(245, 245, 245, 0.67);
  border: 1px solid rgba(230, 230, 230, 1);
}

.img-back {
  width: 727px;
}

.login-right >>> .el-tabs__item {
  height: 80px !important;
  line-height: 80px;
  font-size: 18px;
  padding: 0 50px !important;
}

.wx-login-btn {
  height: 36px;
  line-height: 36px;
  cursor: pointer;
}

.wx-login-btn img {
  vertical-align: middle;
  display: table-cell;
  float: left;
}

.wx-login-btn span {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: rgba(102, 102, 102, 1);
  margin-left: 10px;
  float: left;
}

.bottom-btn {
  width: 100%;
  position: absolute;
  bottom: 20px;
  padding: 0 56px;
  box-sizing: border-box;
}

.bottom-btn a {
  font-size: 14px;
  color: #3672bf;
  /* padding: 0px 20px; */
}

input.code {
  width: 200px !important;
}

.codebtn {
  display: inline-block;
  width: 100px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border: 1px solid rgba(173, 204, 249, 1);
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.67);
  color: #3672bf;
  margin-left: 15px;
  font-weight: bold;
  cursor: pointer;
  float: right;
  font-size: 14px;
}

.nobtn {
  background: #ccc !important;
  border: solid 1px #ccc;
  color: #888;
  cursor: not-allowed;
}
.enterinput {
  width: 310px;
}
@media screen and (max-width: 1400px) {
  .content {
    width: 1100px;
    margin-top: 80px;
  }

  .img-back {
    width: 627px;
  }

  .login-right {
    float: right !important;
    width: 460px;
  }

  .content1 {
    padding: 0px 32px;
  }

  .content1 input {
    width: 320px;
    height: 36px;
  }

  .codebtn {
    height: 36px;
    line-height: 36px;
  }

  .login-right >>> .el-tabs__item {
    height: 80px !important;
    line-height: 80px;
    font-size: 16px;
    padding: 0 44px !important;
  }

  .bottom-btn {
    padding: 0px 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/company/login.vue